// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
const CryptoJS = require("crypto-js");

function getOrCreateTabId(t = undefined) {
    // let tabId = sessionStorage.getItem('tabId');
    let tabId = window.name

    if (!!t) {
        tabId = t;
        window.name = tabId;
    } else if (!tabId) {
        // Generate a random 16-byte tab ID (you can change the byte size as needed)
        const randomBytes = CryptoJS.lib.WordArray.random(16);
        tabId = randomBytes.toString(CryptoJS.enc.Hex);

        // sessionStorage.setItem('tabId', tabId);
        window.name = tabId;
    }

    return tabId;
}

function createNewTabId() {
    const randomBytes = CryptoJS.lib.WordArray.random(16);
    const tabId = randomBytes.toString(CryptoJS.enc.Hex);
    return tabId;
}

function getActiveTabId() {
    let activeTabId = localStorage.getItem('activeTabId');
    return activeTabId;
}

function setActiveTabId(customTabId = undefined) {
    const currentTabId = getOrCreateTabId();
    localStorage.setItem('activeTabId', customTabId || currentTabId);
}

function clearActiveTabId() {
    localStorage.removeItem('activeTabId');
}

export { getOrCreateTabId, createNewTabId, getActiveTabId, setActiveTabId, clearActiveTabId };
